import React from 'react'
import { LayoutBand, Skeleton, useContainerWidth, Separator, FlowGrid } from '@fs/zion-ui'

const HomePageSkeleton = () => {
  // Initiate state variables and hooks
  const atWidth = useContainerWidth()

  return (
    <LayoutBand data-testid="home-page-skeleton">
      <div data-testid="home-page-skeleton-image">
        <Skeleton.Image height={50} />
      </div>
      <div data-testid="home-page-skeleton-image">
        <Skeleton.Image height={275} />
      </div>
      <Separator />
      <div data-testid="home-page-skeleton-image">
        <Skeleton.Image height={60} />
      </div>
      <Separator size="sm" />
      <FlowGrid columnCount={atWidth({ lg: 2 })} data-testid="home-page-skeleton-grid">
        <div data-testid="home-page-skeleton-image">
          <Skeleton.Image height={375} />
        </div>
        <div data-testid="home-page-skeleton-image">
          <Skeleton.Image height={375} />
        </div>
      </FlowGrid>
      <Separator />
      <div data-testid="home-page-skeleton-image">
        <Skeleton.Image height={250} />
      </div>
    </LayoutBand>
  )
}

export default HomePageSkeleton
